var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown-group"},[_c('li',{staticClass:"dropdown-group-header"},[_vm._v(_vm._s(_vm.header))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }